(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lotto/components/start/assets/react/components/start-text.js') >= 0) return;  svs.modules.push('/modules/lotto/components/start/assets/react/components/start-text.js');

'use strict';

const {
  SimpleTime: simpleTime
} = svs.utils.date;
const {
  draws: {
    drawsApi,
    jackpotApi
  },
  jackpot: {
    CONSTANTS: {
      JACKPOT_WINSET
    }
  },
  productMapping
} = svs.numbergames;
const getJackpot = winset => {
  const jackpot = jackpotApi.jackpot({
    product: productMapping.CONSTANTS.LOTTO,
    winset
  });
  const tag = jackpot.tag || 'ca';
  const amountString = jackpot.jackpotAmountString.replace('ca', '');
  return {
    tag,
    amountString
  };
};
const StartText = () => {
  const {
    tag: lotto1JackpotTag,
    amountString: lotto1JackpotAmountString
  } = getJackpot(JACKPOT_WINSET.LOTTO_1);
  const {
    tag: dromvinstTag,
    amountString: dromvinstAmountString
  } = getJackpot(JACKPOT_WINSET.DROMVINST);
  const closeTimeWednesday = simpleTime(drawsApi.regCloseTime('onslotto'));
  const closeTimeSaturday = simpleTime(drawsApi.regCloseTime('lorlotto'));
  let closeTimeText = "Spelstopp onsdagar kl ".concat(closeTimeWednesday, " och l\xF6rdagar kl ").concat(closeTimeSaturday);
  if (closeTimeWednesday === closeTimeSaturday) {
    closeTimeText = "Spelstopp ".concat(closeTimeWednesday, " l\xF6rdagar och onsdagar");
  }
  return React.createElement("div", {
    className: "start-text js-start-text"
  }, React.createElement("p", null, "Dr\xF6mvinsten ".concat(dromvinstTag, " "), React.createElement("span", {
    className: "f-bold"
  }, dromvinstAmountString), " kronor"), React.createElement("p", null, "Jackpot Lotto 1 ".concat(lotto1JackpotTag, " "), React.createElement("span", {
    className: "f-bold"
  }, lotto1JackpotAmountString), " kronor"), React.createElement("p", null, closeTimeText));
};
setGlobal('svs.lotto.react.components', {
  StartText
});

 })(window);